import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface NavbarProps {
  menuOpen: boolean;
  setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}



export default function Navbar({ menuOpen, setMenuOpen }: NavbarProps) {
  // const [menuOpen, setMenuOpen] = useState<boolean>(false);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden'; // Disable scrolling
    } else {
      document.body.style.overflow = 'auto'; // Enable scrolling
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [menuOpen]);

  return (
    <div className="relative ps-0 lg:ps-3">
      {/* <button 
        className={`bg-green px-2 lg:hidden text-${
          menuOpen ? 'gray-700' : 'white'
        } focus:outline-none text-3xl z-10`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? '✖' : '☰'}
      </button> */}

      {menuOpen && (
        <div
          className="fixed inset-0 bg-gray-500/50 backdrop-blur-sm z-10 lg:hidden"
          onClick={() => setMenuOpen(false)}
          onKeyDown={(e) => {
            if (e.key === 'Escape') setMenuOpen(false);
          }}
          role="button"
          tabIndex={0}
          aria-label="Close menu"
        ></div>
      )}
      <nav
        className={`fixed top-0 left-0 text-left h-full lg:bg-transparent shadow-none lg:shadow-none lg:static p-5 lg:p-0
    ${menuOpen ? 'translate-x-0 text-lg text-white w-[285px] bg-gradient-to-b from-[#8c2720] via-[#522522] to-[#0086D6]' : '-translate-x-full text-white'}
    transition-transform duration-500 ease-in-out z-20 flex flex-col lg:flex-row items-center lg:space-x-10 lg:w-auto lg:translate-x-0 font-inter font-normal text-base no-underline`}
      >
        {menuOpen ? (
          <button
            className="text-white absolute -right-6 -top-0 bg-[#8C2720] px-1.5 py-1 text-base lg:hidden rounded-tr-full rounded-br-full"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ✖
          </button>
        ) : (
          ''
        )}
        <Link
          onClick={() => setMenuOpen(false)}
          to="/"
          className="lg:hover:underline w-full lg:w-auto py-3 lg:py-0 px-5 lg:px-0 hover:bg-white/20 lg:hover:bg-transparent border-b border-white/15 lg:border-none"
        >
          Home
        </Link>
        <Link
          onClick={() => setMenuOpen(false)}
          to="/league-table"
          className="lg:hover:underline w-full lg:w-auto py-3 lg:py-0 px-5 lg:px-0 hover:bg-white/20 lg:hover:bg-transparent border-b border-white/15 lg:border-none"
        >
          League Table
        </Link>
        <Link
          onClick={() => setMenuOpen(false)}
          to="/club-profile"
          // className="hover:underline w-full lg:w-auto text-center py-3 lg:py-0 rounded-md bg-customBlue lg:bg-transparent mb-2 lg:mb-0"
          className="lg:hover:underline w-full lg:w-auto py-3 lg:py-0 px-5 lg:px-0 hover:bg-white/20 lg:hover:bg-transparent border-b border-white/15 lg:border-none"
        >
          Club Profiles
        </Link>
        <Link
          onClick={() => setMenuOpen(false)}
          to="/analytics"
          className="lg:hover:underline w-full lg:w-auto py-3 lg:py-0 px-5 lg:px-0 hover:bg-white/20 lg:hover:bg-transparent"
        >
          Analytics
        </Link>
      </nav>
    </div>
  );
}
